module.exports = __webpack_public_path__ + "90d26058a3a05efd461f4f9b8623e512.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-hiking.png
// module id = 2500
// module chunks = 0